export const DISPLAY_DATE_FORMAT = 'dd.MM.yyyy';
export const API_DATE_FORMAT = 'yyyy-MM-dd';
export const TIME_FORMAT = 'HH:mm';
export const DISPLAY_DATETIME_FORMAT = 'dd.MM.yyyy, HH:mm';
export const DISPLAY_SHORT_MONTH_FORMAT = 'MMM yyyy';
export const DISPLAY_MONTH_FORMAT = 'MMMM yyyy';

export const ZURICH_TIMEZONE = 'Europe/Zurich';
